import { render, staticRenderFns } from "./home-menu.vue?vue&type=template&id=731ed60c&scoped=true"
import script from "./home-menu.vue?vue&type=script&lang=js"
export * from "./home-menu.vue?vue&type=script&lang=js"
import style0 from "./home-menu.vue?vue&type=style&index=0&id=731ed60c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731ed60c",
  null
  
)

export default component.exports